export default [
  require("/home/webb/WebstormProjects/file-manager-docs/.docusaurus/docusaurus-plugin-css-cascade-layers/default/layers.css"),
  require("/home/webb/WebstormProjects/file-manager-docs/node_modules/infima/dist/css/default/default.css"),
  require("/home/webb/WebstormProjects/file-manager-docs/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/home/webb/WebstormProjects/file-manager-docs/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/home/webb/WebstormProjects/file-manager-docs/src/css/custom.css"),
];
